var exports = {
  "t": "highlightedText__gOfykr",
};

module.exports = exports;
